import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { FormInputConfig, AllInputTypes, ListValues } from '../../../../../trash/shared/interfaces/form-input-config';
import { ICreateStateRequest, IStateResponse } from '../dtos';
import { patterns } from '../../../../../lib/formly/patterns';

export class CreateStateModel implements ICreateStateRequest {
  referenceId: number;
  englishName: string;
  arabicName: string;
  isActive: boolean | undefined;
  code: string;
  countryId: string;

  constructor(request: ICreateStateRequest) {
    this.referenceId = request.referenceId;
    this.englishName = request.englishName;
    this.arabicName = request.arabicName;
    this.isActive = request.isActive;
    this.code = request.code;
    this.countryId = request.countryId;
  }

  static create(data: ICreateStateRequest): CreateStateModel {
    return new CreateStateModel(data);
  }

  static createDefault(): CreateStateModel {
    return CreateStateModel.create({
      referenceId: 0,
      englishName: '',
      arabicName: '',
      isActive: true,
      code: '',
      countryId: ''
    });
  }

  static createFromItem(item: IStateResponse): CreateStateModel {
    return new CreateStateModel({
      referenceId: item.referenceId,
      englishName: item.englishName,
      arabicName: item.arabicName,
      isActive: item.isActive,
      code: item.code,
      countryId: item.country.id
    });
  }

  getFormConfig(countries: ListValues[], isVisible?: boolean, translate?: TranslateService): FormInputConfig[] {
    return [
      // getIdFormConfig(this.id),
      {
        type: AllInputTypes.Text,
        name: 'englishName',
        label: translate?.instant('LOCATION_MANAGEMENT.STATE_ENGLISH_NAME'),
        placeholder: `${translate?.instant('FORMS.EX')} ${translate?.instant('LOCATION_MANAGEMENT.STATE_ENGLISH_NAME')}`,
        defaultValue: this.englishName,
        isDisable: !isVisible,
        widthClass: 'col-12',
        validation: [
          {
            function: Validators.required,
            errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('LOCATION_MANAGEMENT.STATE_ENGLISH_NAME')}`
          },
          {
            function: Validators.pattern(patterns.onlyEnglishCharacters),
            errorMessage: translate?.instant('SERVICE_MANAGEMENT.VALIDATION_ONLY_ENGLISH'),
            errorName: 'pattern'
          }
        ]
      },
      {
        type: AllInputTypes.Text,
        name: 'arabicName',
        label: translate?.instant('LOCATION_MANAGEMENT.STATE_ARABIC_NAME'),
        placeholder: `${translate?.instant('FORMS.EX')} ${translate?.instant('LOCATION_MANAGEMENT.STATE_ARABIC_NAME')}`,
        defaultValue: this.arabicName,
        isDisable: !isVisible,
        widthClass: 'col-12',
        validation: [
          {
            function: Validators.required,
            errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('LOCATION_MANAGEMENT.STATE_ARABIC_NAME')}`
          },
          {
            function: Validators.pattern(patterns.onlyArabicCharacters),
            errorMessage: translate?.instant('SERVICE_MANAGEMENT.VALIDATION_ONLY_ARABIC'),
            errorName: 'pattern'
          }
        ]
      },
      {
        type: AllInputTypes.Text,
        name: 'code',
        label: translate?.instant('LOCATION_MANAGEMENT.CODE'),
        placeholder: `${translate?.instant('FORMS.EX')} ${translate?.instant('LOCATION_MANAGEMENT.CODE')}`,
        defaultValue: this.code,
        isDisable: !isVisible,
        widthClass: 'col-12',
        validation: [
          {
            function: Validators.required,
            errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('LOCATION_MANAGEMENT.CODE')}`
          }
        ]
      },
      {
        type: AllInputTypes.Select,
        name: 'countryId',
        label: translate?.instant('LOCATION_MANAGEMENT.COUNTRY_NAME'),
        placeholder: translate?.instant('GENERAL.SELECT'),
        widthClass: 'col-12',
        defaultValue: this.countryId,
        isDisable: !isVisible,
        listValues: countries,
        validation: [
          {
            function: Validators.required,
            errorMessage: `${translate?.instant('GENERAL.PLEASE_SELECT')} ${translate?.instant('LOCATION_MANAGEMENT.COUNTRY_NAME')}`
          }
        ]
      },
      {
        type: AllInputTypes.ToggleButton,
        name: 'isActive',
        label: translate?.instant('GENERAL.STATUS'),
        defaultValue: this.isActive ?? true,
        isDisable: !isVisible,
        widthClass: 'col-12'
      }
    ];
  }
}
